var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("normalDialog", {
    attrs: {
      width: "680",
      maxWidth: "680",
      title: _vm.$t(
        "label_essweb_punchCriteriaType_list_dialog_newCriteriaTypeTitle"
      ),
      dialog: _vm.show,
    },
    on: { close: _vm.closeDialog },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "v-form",
              { ref: "form", attrs: { "lazy-validation": "" } },
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c(
                          "v-sheet",
                          { staticClass: "mrc_text_require text--secondary" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "label_essweb_punchCriteriaType_list_dialog_punchCriteriaTypeeLabel"
                                )
                              )
                            ),
                          ]
                        ),
                        _c("v-autocomplete", {
                          attrs: {
                            items: _vm.AllType,
                            "item-text": "criteria_type_name",
                            "item-value": "punch_code",
                            dense: "",
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            filled: "",
                            placeholder: _vm.$t(
                              "label_essweb_punchCriteriaType_list_dialog_punchCriteriaTypeeLabel"
                            ),
                            "single-line": "",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "no-data",
                              fn: function () {
                                return [_c("noContent")]
                              },
                              proxy: true,
                            },
                            {
                              key: "selection",
                              fn: function (data) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(data.item.criteria_type_name)
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                            {
                              key: "item",
                              fn: function (data) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "table-title text--primary",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(data.item.criteria_type_name)
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ]),
                          model: {
                            value: _vm.PunchData.punch_code,
                            callback: function ($$v) {
                              _vm.$set(_vm.PunchData, "punch_code", $$v)
                            },
                            expression: "PunchData.punch_code",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c("inputTextFiledMultiLang", {
                          attrs: {
                            bindData: _vm.PunchData.criteria_type_name,
                            maxlength: "100",
                            TrigerInit: _vm.show,
                            label: _vm.$t(
                              "label_essweb_punchCriteriaType_list_dialog_punchCriteriaNameLabel"
                            ),
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                          },
                          on: {
                            change: function (valueArr) {
                              _vm.PunchData.criteria_type_name = valueArr
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("inputTextFiledMultiLang", {
                          attrs: {
                            bindData: _vm.PunchData.criteria_type_description,
                            maxlength: "500",
                            TrigerInit: _vm.show,
                            label: _vm.$t(
                              "label_essweb_punchCriteriaType_list_dialog_descriptionLabel"
                            ),
                          },
                          on: {
                            change: function (valueArr) {
                              _vm.PunchData.criteria_type_description = valueArr
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c("inputTextFiledMultiLang", {
                          attrs: {
                            bindData: _vm.PunchData.criteria_type_abbr,
                            maxlength: "20",
                            TrigerInit: _vm.show,
                            label: _vm.$t(
                              "label_essweb_punchCriteriaType_list_dialog_abbrLabel"
                            ),
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                          },
                          on: {
                            change: function (valueArr) {
                              _vm.PunchData.criteria_type_abbr = valueArr
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c(
                          "v-sheet",
                          { staticClass: "mrc_text_require text--secondary" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "label_essweb_punchCriteriaType_list_dialog_tableNameLabel"
                                )
                              )
                            ),
                          ]
                        ),
                        _c("v-autocomplete", {
                          attrs: {
                            items: _vm.AllTable,
                            "item-text": "view_fields",
                            "item-value": "value_field",
                            dense: "",
                            disabled: true,
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            filled: "",
                            "append-icon": "",
                            placeholder: _vm.$t(
                              "label_essweb_punchCriteriaType_list_dialog_tableNameLabel"
                            ),
                            "single-line": "",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "no-data",
                              fn: function () {
                                return [_c("noContent")]
                              },
                              proxy: true,
                            },
                            {
                              key: "selection",
                              fn: function (data) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$getCommonLangValue(
                                          data.item.view_fields
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                          ]),
                          model: {
                            value: _vm.PunchData.table_name,
                            callback: function ($$v) {
                              _vm.$set(_vm.PunchData, "table_name", $$v)
                            },
                            expression: "PunchData.table_name",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("v-sheet", { staticClass: "text--secondary" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "label_essweb_punchCriteriaType_list_dialog_remarkLabel"
                              )
                            )
                          ),
                        ]),
                        _c("v-text-field", {
                          attrs: {
                            dense: "",
                            filled: "",
                            maxlength: "500",
                            "single-line": "",
                            label: _vm.$t(
                              "label_essweb_punchCriteriaType_list_dialog_remarkLabel"
                            ),
                            placeholder: _vm.$t(
                              "label_essweb_punchCriteriaType_list_dialog_remarkLabel"
                            ),
                          },
                          model: {
                            value: _vm.PunchData.remarks,
                            callback: function ($$v) {
                              _vm.$set(_vm.PunchData, "remarks", $$v)
                            },
                            expression: "PunchData.remarks",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _c("CardActions", {
              attrs: { newBtn: "" },
              on: { new: _vm.onNewProperty, cancel: _vm.closeDialog },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }